import React, { useState, useEffect } from 'react';

const NotificationToast = ({ notification, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onClose(notification.id), 300);
    }, notification.duration || 5000);

    return () => clearTimeout(timer);
  }, [notification, onClose]);

  const getNotificationIcon = (type) => {
    const icons = {
      'new_offer': '💰',
      'offer_accepted': '✅',
      'offer_rejected': '❌',
      'offer_withdrawn': '🚫',
      'fee_payment_required': '💳',
      'fee_paid': '💸',
      'chat_unlocked': '💬',
      'chat_message': '💬',
      'offer_expired': '⏰',
      'success': '✅',
      'error': '❌',
      'warning': '⚠️',
      'info': 'ℹ️'
    };
    return icons[type] || '🔔';
  };

  const getNotificationColor = (type) => {
    const colors = {
      'new_offer': 'bg-blue-600 border-blue-500',
      'offer_accepted': 'bg-green-600 border-green-500',
      'offer_rejected': 'bg-red-600 border-red-500',
      'offer_withdrawn': 'bg-gray-600 border-gray-500',
      'fee_payment_required': 'bg-yellow-600 border-yellow-500',
      'fee_paid': 'bg-green-600 border-green-500',
      'chat_unlocked': 'bg-purple-600 border-purple-500',
      'chat_message': 'bg-blue-600 border-blue-500',
      'offer_expired': 'bg-orange-600 border-orange-500',
      'success': 'bg-green-600 border-green-500',
      'error': 'bg-red-600 border-red-500',
      'warning': 'bg-yellow-600 border-yellow-500',
      'info': 'bg-blue-600 border-blue-500'
    };
    return colors[type] || 'bg-gray-600 border-gray-500';
  };

  return (
    <div
      className={`
        fixed top-20 right-4 z-50 max-w-sm w-full
        transform transition-all duration-300 ease-in-out
        ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}
      `}
    >
      <div className={`
        rounded-lg border-l-4 p-4 shadow-xl backdrop-blur-sm
        ${getNotificationColor(notification.type)}
        bg-opacity-95 text-white
      `}>
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <span className="text-2xl">{getNotificationIcon(notification.type)}</span>
          </div>
          <div className="ml-3 flex-1">
            <h4 className="text-sm font-bold">{notification.title}</h4>
            <p className="text-sm opacity-90 mt-1">{notification.message}</p>
            {notification.action && (
              <button
                onClick={notification.action.onClick}
                className="mt-2 px-3 py-1 bg-white bg-opacity-20 hover:bg-opacity-30 rounded text-xs font-medium transition-colors"
              >
                {notification.action.label}
              </button>
            )}
          </div>
          <div className="ml-4 flex-shrink-0">
            <button
              onClick={() => {
                setIsVisible(false);
                setTimeout(() => onClose(notification.id), 300);
              }}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const NotificationContainer = ({ notifications, onRemoveNotification }) => {
  return (
    <div className="fixed top-20 right-4 z-50 space-y-2">
      {notifications.map((notification, index) => (
        <div
          key={notification.id}
          style={{ top: `${index * 80}px` }}
          className="relative"
        >
          <NotificationToast
            notification={notification}
            onClose={onRemoveNotification}
          />
        </div>
      ))}
    </div>
  );
};

export { NotificationToast, NotificationContainer };
